export default __webpack_public_path__ + "static/media/premium-image.c9665632.jpg";